import { DatePicker, Select, Option, CheckboxGroup, CheckboxButton} from 'element-ui';

export default {
    name: 'RaceFilterLayout',
    props: {
        filter: Object,
        typesBySport: Array,
        typesByEvent: Array,
        distances: Array,
        statuses: Array,
        years: Array
    },
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
        [CheckboxButton.name]: CheckboxButton,
        [CheckboxGroup.name]: CheckboxGroup,
    },
    watch: {
        status: {
            immediate: true,
            handler(newVal, oldVal) {
                let filter = {...this.filter};
                filter.status = this.status;
                filter.options.page = 1;
                this.$emit("update:filter", filter);
            }
        },
        typeBySport: {
            immediate: true,
            handler(newVal, oldVal) {
                let filter = { ...this.filter };
                filter.typeBySport = this.typeBySport;
                filter.options.page = 1;
                this.$emit("update:filter", filter);
            }
        },
        typeByEvent: {
            immediate: true,
            handler(newVal, oldVal) {
                let filter = { ...this.filter };
                filter.typeByEvent = this.typeByEvent;
                filter.options.page = 1;
                this.$emit("update:filter", filter);
            }
        },
        year: {
            immediate: true,
            handler(newVal, oldVal) {
                let filter = { ...this.filter };
                filter.year = this.year;
                filter.options.page = 1;
                this.$emit("update:filter", filter);
            }
        },
        distance: {
            immediate: true,
            handler() {
                let filter = { ...this.filter };
                filter.distance = this.distance;
                filter.options.page = 1;
                this.$emit("update:filter", filter);
            }
        },
        perPage: {
            immediate: true,
            handler() {
                var options = { ...this.filter.options };
                var filter = { ...this.filter };

                filter.options = options;
                filter.options.perPage = this.perPage;
                this.$emit("update:filter", filter);
            }
        },
    },
    data() {
        return {
            isProcessing: false,
            perPage: 5,
            perPageOptions: [5, 10, 25, 50, 100],
            typeBySport: null,
            typeByEvent: null,
            location: null,
            year: null,
            distance: null,
            status: null,
            name: null,
        }
    },
    computed: {
    },
    methods: {
        console(message) {
            if (console && console.log) {
                if (message) {
                    console.log(message);
                }
                else {
                    var date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        },
        locationChange() {
            let filter = { ...this.filter };
            filter.location = this.location;
            filter.options.page = 1;
            this.$emit("update:filter", filter);
        },
        nameChange() {
            let filter = { ...this.filter };
            filter.name = this.name;
            filter.options.page = 1;
            this.$emit("update:filter", filter);
        },
        usedTiEntryClick(value) {
            let filter = { ...this.filter };
            filter.isUsedTiForEntry = value;
            filter.options.page = 1;
            this.$emit("update:filter", filter);
        }
    },
    mounted() {
        var self = this;
        self.perPage = self.filter.options.perPage;
        self.typeBySport = self.filter.typeBySport;
        self.typeByEvent = self.filter.typesByEvent;
        self.location = self.filter.location;
        self.year = self.filter.year;
        self.distance = self.filter.distance;
        self.status = self.filter.status;
        self.name = self.filter.name;
    }
};



// WEBPACK FOOTER //
// ./src/components/admin/races/filter-bar/filter-bar.js